import axios from 'axios'
import dayjs from 'dayjs'

const formatDate = (date, format = 'YYYY-MM-DD') => {
  return dayjs(date).format(format)
}

export const getSpotSummaries = async (startDate, endDate) => {
  const queryStartDate = formatDate(startDate)
  const queryEndDate = formatDate(endDate)

  const res = await axios
    .get('/markets/api/spot_summaries', {
      params: {
        start_date: queryStartDate,
        end_date: queryEndDate,
      },
    })
    .catch((_error) => {
      return undefined
    })

  if (res && 'data' in res) return res.data

  return undefined
}

export const getSpotSummariesDetail = async (startDate, endDate, area) => {
  const queryStartDate = formatDate(startDate)
  const queryEndDate = formatDate(endDate)

  const res = await axios
    .get('/markets/api/spot_summaries/detail', {
      params: {
        start_date: queryStartDate,
        end_date: queryEndDate,
        area: area,
      },
    })
    .catch((_error) => {
      return undefined
    })

  if (res && 'data' in res) return res.data

  return undefined
}
